import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";

const PartFilters = ({ loadData, parts }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          payload[key] = filters[key].value;
        } else {
          payload[key] = filters[key];
        }
      }

      loadData({
        ...payload,
      });
    } else {
      loadData();
    }
  };

  const filterTypes = [{ label: "Filter Part", value: "description" }];
  const renderFilterInput = () => {
    switch (filterType) {
      case "description":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={parts?.map((ele) => ({
              label: ele.description,
              value: ele.description,
            }))}
            placeholder="Search Part"
          />
        );

      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default PartFilters;
